export default __webpack_public_path__ + "static/2-a77dff2845c5806ca4892c17e0e0c987.webp";